import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
// DevExtreme
import { loadMessages } from "devextreme/localization";
import enMessages from "devextreme/localization/messages/en.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
//
import App from "./App";

// ----------------------------------------------------------------------

export const loaderRoot = ReactDOM.createRoot(document.getElementById("loader"));

const root = ReactDOM.createRoot(document.getElementById("root"));

loadMessages(enMessages);
loadMessages(esMessages);
loadMessages(ptMessages);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
